export const environment = {
  production: true,
  apiurl: 'https://demo-aer-api.pagewerkz.com',
};
